import { CloseTransactionAgentDTO, CloseTransactionDTO } from "common/dto";
import { FormValidations } from "common/hooks";
import { isNonEmpty, numericValue } from "common/utils";
import moment from 'moment';

type Options = { [key: string]: string }

const isValidAgent = (agent: CloseTransactionAgentDTO) => {
  return isNonEmpty(agent.type) && isNonEmpty(agent.name) && isNonEmpty(agent.contact) && ((agent.type === 'I' && numericValue(agent.commission) !== undefined) || agent.type === 'E');
}

const sumAgentCommission = (agents?: CloseTransactionAgentDTO[]) => {
  return agents?.map(ba => Number(ba?.commission ?? 0) ).reduce((a, b) => a + b, 0) ?? 0;
}

const closeTransactionFormValidations = (lang: Options): FormValidations<CloseTransactionDTO> => [
  (values) => (values.price || !values.canEditSellerFields) ? null : [
    ['price', lang.pleaseInput + lang.captionPrice],
  ],
  (values) => (values.transactionDate || !values.canEditSellerFields) ? null : [
    ['transactionDate', lang.pleaseSelect + lang.captionTransactionDate],
  ],
  (values) => ((values.premises && isNonEmpty(values.premises.trim())) || !values.canEditSellerFields) ? null : [
    ['premises', lang.pleaseInput + lang.titlePremises],
  ],
  (values) => !values.canEditSellerFields ? null :
  ((isNonEmpty(values.initialDeposit?.toString()))) ? null : [
    ['initialDeposit', lang.pleaseInput + lang.captionInitialDeposit],
  ],
  (values) => !isNonEmpty(values.initialDeposit) ? null :
    ((Number(values.initialDeposit) ?? 0) <= (values.price ?? 0) && (Number(values.bigDeposit) ?? 0) + (Number(values.initialDeposit) ?? 0) <= (values.price ?? 0)) ? null : [
      ['initialDeposit', lang.msgInvalidInitialDepositAndBigDepositSum],
  ],
  (values) => !values.canEditSellerFields ? null :
    values.initialDepositDueDate ? (values.transactionDate && (moment(values.initialDepositDueDate) >= moment(values.transactionDate))) ? null : [
  	['initialDepositDueDate', lang.msgInvalidInitialDepositDate]
  ] : [
    ['initialDepositDueDate', lang.pleaseInput + lang.captionInitialDeposit],
  ],
  (values) => !values.canEditSellerFields ? null :
  (isNonEmpty(values.bigDeposit?.toString())) ? null : [
    ['bigDeposit', lang.pleaseInput + lang.captionBigDeposit],
  ],
  (values) => !isNonEmpty(values.bigDeposit) ? null :
    ((Number(values.bigDeposit) ?? 0) <= (values.price ?? 0) && (Number(values.bigDeposit) ?? 0) + (Number(values.initialDeposit) ?? 0) <= (values.price ?? 0)) ? null : [
      ['bigDeposit', lang.msgInvalidInitialDepositAndBigDepositSum],
  ],
  (values) => !values.canEditSellerFields ? null :
    values.bigDepositDueDate ? (values.initialDepositDueDate && (moment(values.bigDepositDueDate) >= moment(values.initialDepositDueDate))) ? null : [
  	['bigDepositDueDate', lang.msgInvalidBigDepositDate]
  ] : [
    ['bigDepositDueDate', lang.pleaseInput + lang.captionBigDeposit],
  ],
  (values) => (isNonEmpty(values.completion?.toString()) || !(values.tranType === 'SALE') || !values.canEditSellerFields) ? null : [
    ['completion', lang.pleaseInput + lang.captionCompletion],
  ],
  (values) => (values.tranType === 'SALE') && values.canEditSellerFields ? values.completionDueDate ? (values.bigDepositDueDate && (moment(values.completionDueDate) >= moment(values.bigDepositDueDate))) ? null : [
    ['completionDueDate', lang.msgInvalidCompletionDate]] : [
    ['completionDueDate', lang.pleaseSelect + lang.date],
  ] : null,
  (values) => ((values.sellerComm !== undefined && values.sellerComm !== null) || !values.canEditSellerFields) ? null : [
    ['sellerComm', lang.pleaseInput + lang.captionCommission],
  ],
  //If all agents are internal, commision must be equal to total commission
  (values) => ((values.sellerAgents?.filter(agent => agent.type === 'I').length === values.sellerAgents?.length) && (values.sellerComm ?? 0) == sumAgentCommission(values.sellerAgents)) || values.sellerAgents?.filter(agent => agent.type === 'I').length !== values.sellerAgents?.length || !values.canEditSellerFields ? null : [
    ['sellerComm', values.tranType === 'SALE' ? lang.msgSellerAgentCommNotEqual : lang.msgLandlordAgentCommNotEqual],
  ],
  (values) => (!values.sellerComm || !values.canEditSellerFields) || (values.sellerComm ?? 0) >= sumAgentCommission(values.sellerAgents) ? null : [
    ['sellerComm', values.tranType === 'SALE' ? lang.msgSellerAgentCommExceed : lang.msgLandlordAgentCommExceed],
  ],
  (values) => values.canEditSellerFields ? values.sellerCommReceivedDate ? values.tranType === 'SALE' ? (values.completionDueDate && (moment(values.sellerCommReceivedDate) >= moment(values.completionDueDate))) ? null : [
    ['sellerCommReceivedDate', lang.msgInvalidSellerCommissionReciveDate]] : (values.bigDepositDueDate && (moment(values.sellerCommReceivedDate) >= moment(values.bigDepositDueDate))) ? null : [
      ['sellerCommReceivedDate', lang.msgInvalidLandlordCommissionReciveDate]] : [
    ['sellerCommReceivedDate', lang.pleaseSelect + (values.tranType === 'SALE' ? lang.captionSellerCommReceivedDate : lang.captionLandlordCommReceivedDate)],
  ] : null,
  // (values) => (values.sellerCommAgentShare || !values.canEditSellerFields) ? null : [
  //   [ 'sellerCommAgentShare', lang.pleaseInput + lang.captionCommissionShareForAgents ],
  // ],
  // (values) => (values.sellerCommAgentShare || !values.canEditSellerFields) ? null : [
  //   [ 'sellerCommAgentShare', lang.pleaseInput + lang.captionCommissionShareForAgents ],
  // ],
  (values) => ((values.buyerComm !== undefined && values.buyerComm !== null) || !values.canEditBuyerFields) ? null : [
    ['buyerComm', lang.pleaseInput + lang.captionCommission],
  ],
  //If all agents are internal, commision must be equal to total commission
  (values) => ((values.buyerAgents?.filter(agent => agent.type === 'I').length === values.buyerAgents?.length) && (values.buyerComm ?? 0) == sumAgentCommission(values.buyerAgents)) || (values.buyerAgents?.filter(agent => agent.type === 'I').length !== values.buyerAgents?.length) || !values.canEditBuyerFields ? null : [
    ['buyerComm', values.tranType === 'SALE' ? lang.msgBuyerAgentCommNotEqual : lang.msgTenantAgentCommNotEqual],
  ],
  (values) => (!values.buyerComm || !values.canEditBuyerFields) || (values.buyerComm ?? 0) >= sumAgentCommission(values.buyerAgents) ? null : [
    ['buyerComm', values.tranType === 'SALE' ? lang.msgBuyerAgentCommExceed : lang.msgTenantAgentCommExceed],
  ],
  (values) => values.canEditBuyerFields ? values.buyerCommReceivedDate ? values.tranType === 'SALE' ? (values.completionDueDate && (moment(values.buyerCommReceivedDate) >= moment(values.completionDueDate))) ? null : [
    ['buyerCommReceivedDate', lang.msgInvalidBuyerCommissionReciveDate]] : (values.bigDepositDueDate && (moment(values.buyerCommReceivedDate) >= moment(values.bigDepositDueDate))) ? null : [
      ['buyerCommReceivedDate', lang.msgInvalidTenantCommissionReciveDate]] : [
    ['buyerCommReceivedDate', lang.pleaseSelect + (values.tranType === 'SALE' ? lang.captionBuyerCommReceivedDate : lang.captionTenantCommReceivedDate)],
  ] : null,
  // (values) => (values.buyerCommAgentShare || !values.canEditBuyerFields) ? null : [
  //   [ 'buyerCommAgentShare', lang.pleaseInput + lang.captionCommissionShareForAgents ],
  // ],
  (values) => ((values.buyerAgents?.filter(a => !isValidAgent(a)).length ?? 0) === 0 || !values.canEditBuyerFields) ? null : [
    ['hasInvalidBuyerAgent', lang.pleaseInput],
  ],
  (values) => ((values.sellerAgents?.filter(a => !isValidAgent(a)).length ?? 0) === 0 || !values.canEditSellerFields) ? null : [
    ['hasInvalidSellerAgent', lang.pleaseInput],
  ],

  // Check clientId for internal signing buyer side agent
  (values) => values.buyerAgents?.filter(a => !a.linkedBuyerClientId && a.shouldSign && a.type === 'I')
    .filter(() => values.canEditBuyerFields)
    .map(a => [`invalidLinkedClientId-${a.agentId}` as any, values.tranType === 'SALE' ? lang.msgSpecifyBuyerClient : lang.msgSpecifyTenantClient]) ?? [],
];

export default closeTransactionFormValidations;